// File Metadata:
// Filename: apiSlice.js
// Version: 1.00
// Created: 2025-02-10 22:15:49
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials } from '../../features/auth/authSlice'
import { logOut } from '../../features/auth/authSlice'  // Add this import
import { tokenService } from '../../services/tokenService';

const baseQuery = fetchBaseQuery({
	//baseUrl: 'https://inbounddashboard-api.onrender.com',
	//baseUrl: 'https://178.118.3.215:5000',
	//baseUrl: 'http://localhost:5000',
	//baseUrl: 'https://inbounddashboard-api.vercel.app',
	//baseUrl: 'https://inbounddashboard-api.up.railway.app',
	//baseUrl: 'https://inbounddashboard-api.cyclic.app/',
    baseUrl: '/api/',
	credentials: 'include',
	prepareHeaders: (headers, { getState }) => {
		const token = getState().auth.token

		if (token) {
			headers.set('authorization', `Bearer ${token}`)
		}
		return headers
	}
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions)

    if (result?.error?.status === 401 || result?.error?.status === 403) {
        console.log('Token expired, attempting refresh')
        try {
            const refreshResult = await baseQuery('/auth/refresh', api, extraOptions)
            
            if (refreshResult?.data) {
                console.log('Refresh successful, updating credentials')
                api.dispatch(setCredentials(refreshResult.data))
                // Retry original query
                result = await baseQuery(args, api, extraOptions)
            } else {
                console.log('Refresh failed, logging out')
                tokenService.clearTokens()
                api.dispatch(logOut())
            }
        } catch (err) {
            console.error('Refresh failed:', err)
            tokenService.clearTokens()
            api.dispatch(logOut())
        }
    }

    return result
}

export const apiSlice = createApi({
	baseQuery: baseQueryWithReauth,
	tagTypes: ['Reception', 'User', 'Vendor', 'Attachment', 'ShipmentLog', 'Crossdock', 'Note', 'Crew'],
	endpoints: builder => ({
        updateField: builder.mutation({
            query: ({ collection, id, field, value }) => ({
                url: '/generic/update',
                method: 'PATCH',
                body: { collection, id, field, value }
            }),
            invalidatesTags: (result, error, { collection }) => [{ type: collection, id: 'LIST' }],
        }),
    }),
});

export const { useUpdateFieldMutation } = apiSlice;